import { object, string, array, number, SchemaOf, mixed } from 'yup';

import { KubernetesRbacFormValues, KubernetesUnifiedAccess } from './types';

const accessListValidationSchema: SchemaOf<KubernetesUnifiedAccess> = object({
  Id: number().required(),
  Type: mixed<KubernetesUnifiedAccess['Type']>().required(),
  Name: string().required(),
  Role: object({
    Id: number().required(),
    Name: string().required(),
  }).required(),
  namespaces: array().of(string().required()).optional(),
});

export const kubernetesRBACValidationSchema: SchemaOf<KubernetesRbacFormValues> =
  object({
    name: string()
      .required('Policy name is required')
      .trim()
      .min(1, 'Policy name is required'),
    environmentGroupIds: array(number().required()),
    accessList: array(accessListValidationSchema)
      .required('At least one user or team access is required')
      .min(1, 'At least one user or team access is required'),
  });
